import parallaxAnimation from "./modules/paralax-animation-home.js";
import videoBannerAnimation from "./modules/video-banner-animation.js";
import headerAnimation from "./modules/header-animation.js";
import fadeInAnimation from "./modules/home-fade-in-animations.js";
import textDoBigThings from "./modules/do-big-things.js";
import initializeFadeAnimations from "./modules/fade-animations.js";
import pinDesktopText from "./modules/pin-text.js";
import loadMoreWorks from "./modules/load-works.js";
import loadMoreNews from "./modules/load-news.js";
import workPageAnimation from "./modules/work-page-animations.js";
import setModal from "./modules/modal-work-detail.js";
import setSliders from "./modules/swiper-work-detail.js";
import flipAnimation from "./modules/flip-work-detail-anim.js";
import fadeLayoutInit from "./modules/layout-work-detail-anim.js";
import animateHorizontalImage from "./modules/more-work-anim.js";
import openContactForm from "./modules/open-contact-form.js";
import contactHomeAnim from "./modules/home-contact-anim.js";
import mobileHomeAnimations from "./modules/home-mobile-works-news-anim.js";
import aboutUsAnimations from "./modules/about-us-animations.js";
import initContactForm, { setFileDragDrop } from "./modules/form-contact.js";
import redirectBtnContact, {
  setPlayVideo,
} from "./modules/home-redirect-btn.js";
import { handleCookieBanner } from "./modules/cookies.js";

const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function initFunctionality() {
  if (!prefersReducedMotion) {
    videoBannerAnimation();
    parallaxAnimation();
    fadeInAnimation();
    textDoBigThings();
    initializeFadeAnimations();
    pinDesktopText();
    workPageAnimation();
    setSliders();
    flipAnimation();
    fadeLayoutInit();
    contactHomeAnim();
    animateHorizontalImage();
    mobileHomeAnimations();
    aboutUsAnimations();
    setPlayVideo();
  } else {
    document.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.removeAttribute("autoplay");
    });
  }

  headerAnimation();
  loadMoreWorks();
  loadMoreNews();
  setModal();
  openContactForm();
  handleCookieBanner();

  const contactForm = new initContactForm();
  setFileDragDrop(contactForm);
  redirectBtnContact();
}

function showLoader() {
  const loader_duration = prefersReducedMotion ? 0 : 1500;

  return new Promise((resolve) => {
    document.body.classList.add("loader-active");
    document.documentElement.style.overflow = "hidden";

    const loader = document.querySelector(".loader-page");
    if (loader && typeof lottie !== "undefined" && !prefersReducedMotion) {
      lottie.loadAnimation({
        container: loader,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: `${document.documentElement.dataset.assetsBase || "assets"}/lottie/loader-white.json`,
      });
    }
    setTimeout(() => {
      if (loader) loader.style.display = "none";
      document.documentElement.style.overflow = "auto";
      document.body.classList.remove("loader-active");
      resolve();
    }, loader_duration);
  });
}

async function initPage() {
  try {
    await showLoader();
    initFunctionality();

    if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
  } catch (error) {
    console.error("error", error);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initPage();
});
